export default __webpack_public_path__ + "ecb61fd3024afb5d6db7883e34694e1b.svg";